// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import useUserStore from '@/app/store/modules/user';
import actionsUsers from '../../api/actionsUsers';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import { columnsUser, columnsUserId } from './columnDef/columnsUser';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import USERS from '../../api/apiUrls';
import Permissions from '@/app/permissions/Permissions';

/**
 *
 * @param root0
 * @param root0.organizationId
 * @param root0.pageActions
 * @param root0.filtersEventName
 * @returns {JSX} UsersTable
 */
function UsersTable({ organizationId = undefined, pageActions = undefined, filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchUsers: refetchFromStore, storeRefetchUsers, query: queryStored, storeQuery } = useUserStore();

    // Constants
    const QUERY_PRESETS = {
        filters: [
            {
                key: 'organization',
                value: organizationId || rootOrganization.uuid,
                hidden: true
            }
        ]
    };
    const initialQuery = getInitialQuery(QUERY_PRESETS);

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, error, refetch } = actionsUsers.getUsers(query, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchUsers(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsUser({ query, setQuery, queryStored, storeQuery, setLaunchRefetch, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsUserId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            pageActions={pageActions}
            exportProps={!organizationId ?
                {
                    permissions: [
                        Permissions.EXPORT_MONETICS_USERS.name
                    ],
                    api: USERS.EXPORT_MONETICS_USERS
                } : null
            }
        />
    );
}

export default UsersTable;

UsersTable.propTypes = {
    organizationId: PropTypes.string,
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};